import React from "react";
import { Link } from "react-router-dom"; // Import Link for routing
import Button from "@mui/material/Button";

// Import all icons
import KnowledgeShareIcon from "../../../assets/images/knowledge_share.svg";
import SelfAsIcon from "../../../assets/images/self_asses_icon.svg";
import ActivityBibleIcon from "../../../assets/images/activity_bible_icon.svg";
import EscalationIcon from "../../../assets/images/escalation_icon.svg";
import CustomerIcon from "../../../assets/images/customer_icon.svg";
import trainingIcon from "../../../assets/images/training.png";
import handbookicon from "../../../assets/images/handbook.png";
import starmaterialIcon from "../../../assets/images/starmaterial.png";
import styles from "./QuickLinks.module.css";

// Define the type for link items
interface LinkItem {
  icon: string;
  title: string;
  link1: string;
  link2: string;
}

// Array containing the data for each link item
const linkData: LinkItem[] = [
  {
    icon: KnowledgeShareIcon,
    title: "Knowledge Management",
    link1: "https://abinbevww.service-now.com/nav_to.do?uri=%2F$knowledge.do", // for button Snow
    link2: "https://ab-inbev.acadia.sysalli.com/documents", // for button Acadia
  },
  // {
  //   icon: SelfAsIcon,
  //   title: "Self Assessment Portal",
  //   link1: "",
  //   link2: ""
  // },
  // {
  //   icon: ActivityBibleIcon,
  //   title: "Activity Bible",
  //   link1: "",
  //   link2: "",
  // },
  // {
  //   icon: EscalationIcon,
  //   title: "Escalation Management",
  //   link1: "",
  //   link2: "",
  // },
  // {
  //   icon: CustomerIcon,
  //   title: "Customer Centricity",
  //   link1: "", // for button Snow
  //   link2: "", // for button Acadia
  // },
];

const QuickLinks: React.FC = () => {
  return (
    <div>
      <div style={{ padding: "30px 0px", fontWeight: "600" }}>Quick Links</div>

      <div className={styles.quicklinkDiv}>
        {linkData.map((link, index) => (
          <div key={index} className={styles.linkItem}>
            <div>
              <img src={link.icon} alt={link.title} height={40} width={40} />
              <p>{link.title}</p>
            </div>
            <div className={styles.buttons}>
              <a href={link.link1} target="_blank">
                <Button
                  variant="contained"
                  sx={{
                    background:
                      "var(--ABI-Brand-Colour, linear-gradient(238deg, #D7A833 1.68%, #F4DF03 91.8%))",
                    padding: "10px 40px",
                    fontWeight: "600",
                    "&:hover": {
                      background:
                        "var(--ABI-Brand-Colour, linear-gradient(238deg, #D7A833 1.68%, #F4DF03 91.8%))",
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      border: "2px solid #D7A833",
                       maxWidth:"82%"
                    },
                  }}
                >
                  Snow
                </Button>
              </a>
              <a href={link.link2} target="_blank">                <Button
                variant="contained"
                sx={{
                  background:
                    "var(--ABI-Brand-Colour, linear-gradient(238deg, #D7A833 1.68%, #F4DF03 91.8%))",
                  padding: "10px 40px",
                  fontWeight: "600",
                
                  "&:hover": {
                    background:
                      "var(--ABI-Brand-Colour, linear-gradient(238deg, #D7A833 1.68%, #F4DF03 91.8%))",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    border: "2px solid #D7A833",
                    maxWidth:"82%"
                  },
                }}
              >
                Acadia
              </Button>
              </a>
            </div>
          </div>
        ))}

        {/* <div className={styles.linkItem}>
          <div className={styles.showimg}>
            <a target="blank" href="https://kria.ab-inbev.com/">
              <img src={CustomerIcon} alt='{link.title}' height={40} width={40} />
              <p>Customer Centricity</p>
            </a>
          </div>
        </div> */}
        <div className={styles.linkItem}>
          <div className={styles.showimg}>
            <a target="blank" href="https://supplychain.ab-inbev.com/">
              <img src={SelfAsIcon} alt='{link.title}' height={40} width={40} />
              <p>Self Assessment Portal</p>
            </a>
          </div>
        </div> 
        <div className={styles.linkItem}>
          <div className={styles.showimg}>
            <a target="blank" href='https://anheuserbuschinbev.sharepoint.com/:f:/s/GlobalOperationalExcellenceProgram/Eip23gp-C6dFgNByfrd_2WoBvIBuesSGa7bC2gaETaQ1Hg?e=NY0ipK'>
              <img src={handbookicon} alt='{link.title}' height={40} width={40} />
              <p>Handbook</p>
            </a>
          </div>
        </div>
        <div className={styles.linkItem}>
          <div className={styles.showimg}>
            <a target="blank" href="https://anheuserbuschinbev.sharepoint.com/:f:/s/GlobalOperationalExcellenceProgram/EunOJAx1WThJq_3TpKGUyhcBFbuGv3JxCllm3DYIt9WIRg?e=GawHXJ">
              <img src={starmaterialIcon} alt='{link.title}' height={40} width={40} />
              <p>Star Materials </p>
            </a>
          </div>
        </div>
        <div className={styles.linkItem}>
          <div className={styles.showimg}>
            <a target="blank" href="https://anheuserbuschinbev.sharepoint.com/:f:/s/GlobalOperationalExcellenceProgram/Eh_1QxRN7kVGpyttmB6hFnkBVD1REH4-8aKuejFkuiWIlQ?e=n8vdOM">
              <img src={trainingIcon} alt='{link.title}' height={40} width={40} />

              <p>Training </p>
            </a>
          </div>
        </div>

      </div>
    </div>
  );
};

export default QuickLinks;
